import { createContext, useContext } from 'react';
import type { Theme } from './theme';
import type { Surface } from './surface';

export interface ThemeValue {
  /** تفضيل المستخدم داخل المنصة (لا أثر له خارجها) */
  theme: Theme;
  /** ما يُعرض فعلاً بعد حساب السطح */
  resolved: Theme;
  /** سطح الشاشة الحالي — المبدّل لا يظهر إلا في `app` */
  surface: Surface;
  setTheme: (theme: Theme) => void;
}

export const ThemeContext = createContext<ThemeValue | null>(null);

export function useTheme(): ThemeValue {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme خارج ThemeProvider');
  return ctx;
}
